(() => {
  if (window.__powlifeSmoothFeatureCarouselReady) return;
  window.__powlifeSmoothFeatureCarouselReady = true;

  const STYLE_ID = 'powlife-smooth-feature-carousel-style';

  const ensureStyle = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .pl-story--published .pl-story__visual{overflow:hidden!important}
      .pl-story--published .pl-story__track{
        position:relative!important;
        width:100%!important;
        height:100%!important;
        min-height:500px!important;
        display:flex!important;
        align-items:center!important;
        gap:18px!important;
        will-change:transform;
        transition:none!important
      }
      .pl-story--published .pl-story__track .pl-story__slide{
        position:relative!important;
        inset:auto!important;
        top:auto!important;
        left:auto!important;
        right:auto!important;
        flex:0 0 calc((100% - 36px)/3)!important;
        width:auto!important;
        height:360px!important;
        margin:0!important;
        overflow:hidden;
        opacity:.68;
        transform:scale(.89)!important;
        transition:transform .62s cubic-bezier(.22,.61,.36,1),opacity .48s ease,box-shadow .48s ease!important
      }
      .pl-story--published .pl-story__track .pl-story__slide img{display:block;width:100%;height:100%;object-fit:cover}
      .pl-story--published .pl-story__track .pl-story__slide.is-active{
        z-index:2;
        opacity:1;
        transform:scale(1)!important;
        box-shadow:0 0 0 1px #bbc0bd
      }
      .pl-story--published .pl-story__track .pl-story__slide.is-prev,
      .pl-story--published .pl-story__track .pl-story__slide.is-next{
        opacity:.72;
        transform:scale(.89)!important
      }
      .pl-story--published .pl-story__text.is-active{animation:plSmoothStoryCopyIn .48s ease both!important}
      @keyframes plSmoothStoryCopyIn{from{opacity:0;transform:translateX(18px)}to{opacity:1;transform:none}}
      @media(max-width:989px){
        .pl-story--published .pl-story__track{min-height:430px!important}
        .pl-story--published .pl-story__track .pl-story__slide{height:350px!important}
      }
      @media(max-width:749px){
        .pl-story--published .pl-story__track{min-height:0!important;height:100%!important;gap:12px!important}
        .pl-story--published .pl-story__track .pl-story__slide{
          flex-basis:100%!important;
          width:auto!important;
          height:84%!important;
          opacity:.25;
          transform:scale(.92)!important
        }
        .pl-story--published .pl-story__track .pl-story__slide.is-active{opacity:1;transform:scale(1)!important}
        .pl-story--published .pl-story__track .pl-story__slide.is-prev,
        .pl-story--published .pl-story__track .pl-story__slide.is-next{opacity:.25;transform:scale(.92)!important}
      }
      @media(prefers-reduced-motion:reduce){
        .pl-story--published .pl-story__track,
        .pl-story--published .pl-story__track .pl-story__slide,
        .pl-story--published .pl-story__text.is-active{transition:none!important;animation:none!important}
      }
    `;
    document.head.appendChild(style);
  };

  const enhance = (story) => {
    if (!story || story.dataset.powlifeSmoothReady === 'true') return;

    const track = story.querySelector('[data-feature-track]');
    const slides = [...story.querySelectorAll('[data-feature-slide]')];
    const texts = [...story.querySelectorAll('[data-feature-text]')];
    if (!track || slides.length < 2) return;

    story.dataset.powlifeSmoothReady = 'true';
    ensureStyle();

    const replaceControl = (selector) => {
      const oldButton = story.querySelector(selector);
      if (!oldButton) return null;
      const newButton = oldButton.cloneNode(true);
      oldButton.replaceWith(newButton);
      return newButton;
    };

    const prevButton = replaceControl('[data-feature-prev]');
    const nextButton = replaceControl('[data-feature-next]');

    let moving = false;
    const loopGroups = 11;
    const middleGroup = Math.floor(loopGroups / 2);
    let centerPosition = middleGroup * slides.length;
    const motionDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 620;

    slides.forEach((slide, index) => {
      slide.dataset.featureIndex = String(index);
      slide.classList.remove('is-prev', 'is-active', 'is-next');
    });

    const loop = document.createDocumentFragment();
    for (let group = 0; group < loopGroups; group += 1) {
      slides.forEach((slide, index) => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-feature-slide');
        clone.removeAttribute('data-index');
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.featureIndex = String(index);
        clone.classList.remove('is-prev', 'is-active', 'is-next');
        loop.appendChild(clone);
      });
    }
    track.replaceChildren(loop);

    const featureAt = (position) => ((position % slides.length) + slides.length) % slides.length;

    const setSlideClasses = (activeIndex = featureAt(centerPosition)) => {
      const previousIndex = featureAt(activeIndex - 1);
      const nextIndex = featureAt(activeIndex + 1);
      [...track.children].forEach((slide) => {
        const slideIndex = Number(slide.dataset.featureIndex || 0);
        slide.classList.remove('is-prev', 'is-active', 'is-next');
        if (slideIndex === activeIndex) slide.classList.add('is-active');
        if (slideIndex === previousIndex) slide.classList.add('is-prev');
        if (slideIndex === nextIndex) slide.classList.add('is-next');
      });
    };

    const setCopy = (activeIndex) => {
      texts.forEach((text, index) => text.classList.toggle('is-active', index === activeIndex));
      const counter = story.querySelector('[data-feature-current]');
      if (counter) counter.textContent = String(activeIndex + 1).padStart(2, '0');
    };

    const stepSize = () => {
      if (!track.children.length) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return track.children[0].getBoundingClientRect().width + gap;
    };

    const trackX = (position = centerPosition) => {
      const visibleOffset = window.matchMedia('(max-width: 749px)').matches ? 0 : 1;
      const anchor = track.children[position - visibleOffset];
      return anchor ? -anchor.offsetLeft : -(position - visibleOffset) * stepSize();
    };

    const resetTrack = () => {
      track.getAnimations().forEach((animation) => animation.cancel());
      const x = trackX();
      track.style.transform = `translate3d(${x}px,0,0)`;
      const activeIndex = featureAt(centerPosition);
      setSlideClasses(activeIndex);
      setCopy(activeIndex);
    };

    const animateTrack = async (fromX, toX) => {
      const from = `translate3d(${fromX}px,0,0)`;
      const to = `translate3d(${toX}px,0,0)`;
      if (!motionDuration || typeof track.animate !== 'function') {
        track.style.transform = to;
        return;
      }
      const animation = track.animate(
        [{ transform: from }, { transform: to }],
        { duration: motionDuration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' }
      );
      try { await animation.finished; } catch (_) {}
      try { animation.commitStyles(); } catch (_) { track.style.transform = to; }
      animation.cancel();
    };

    const move = async (direction) => {
      if (moving || slides.length < 2) return;
      moving = true;
      try {
        const nextPosition = centerPosition + direction;
        const minimumCenter = 1;
        const maximumCenter = track.children.length - 2;
        if (nextPosition < minimumCenter || nextPosition > maximumCenter) {
          centerPosition = (middleGroup * slides.length) + featureAt(centerPosition);
          track.style.transform = `translate3d(${trackX()}px,0,0)`;
        }
        const fromX = trackX(centerPosition);
        centerPosition += direction;
        const activeIndex = featureAt(centerPosition);
        setCopy(activeIndex);
        setSlideClasses(activeIndex);
        await animateTrack(fromX, trackX(centerPosition));
      } finally {
        moving = false;
      }
    };

    prevButton?.addEventListener('click', () => move(-1));
    nextButton?.addEventListener('click', () => move(1));

    story.querySelectorAll('[data-story-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        if (tab.dataset.storyTab === 'features') requestAnimationFrame(resetTrack);
      });
    });

    window.addEventListener('resize', resetTrack, { passive: true });
    requestAnimationFrame(resetTrack);
  };

  const init = (scope = document) => {
    if (scope.matches?.('.pl-story--published[data-feature-carousel]')) enhance(scope);
    scope.querySelectorAll?.('.pl-story--published[data-feature-carousel]').forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    requestAnimationFrame(() => init(document));
  }

  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => init(event.target));
  });
})();
